<footer class="footer-container">
  <p>&copy; {{ currentYear }} - Luminary Technologies Pty. Ltd.</p>
  <button type="button" class="btn share-button" (click)="openShareModal()" title="Share this page">
    <i class="bi bi-share"></i>
  </button>
</footer>
